import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-tos',
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.css']
})
export class TosComponent implements OnInit {

  constructor(private titleService: Title) {
    titleService.setTitle('Wissle Terms');
  }

  ngOnInit() {
  }

}
